import React, { Dispatch, SetStateAction } from "react";

import { Theme, css, styled, useMediaQuery } from "@mui/material";

import { LadyCardV3Basic } from "@/components/lady-cards/lady-card-v3";
import { Pagination } from "@/lib/pagination/Pagination";
import { useSearchParamsContextV2 } from "@/shared/search-params-context";

import { useSearchPageContext } from "../context";
import { SearchPageUrlSearchParams } from "../models";
import { LadiesEmptyState } from "./LadiesNoResults";

export const Container = styled("div")(({ theme }) => {
  return css`
    height: min-content;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    row-gap: 30px;
    column-gap: 20px;
    grid-auto-rows: 1fr;
    place-items: center top;
    padding: 20px;
    padding-top: 0;

    ${theme.breakpoints.down("xl")} {
      padding-inline: 10px;
    }

    ${theme.breakpoints.down("sm")} {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  `;
});

export const LadiesResults: React.FC = () => {
  const { data, pageCount, toggleLadyFavorite } = useSearchPageContext();
  const { urlSearchParams, setUrlSearchParams } = useSearchParamsContextV2(
    SearchPageUrlSearchParams,
  );

  const mixPageToParams = (page: number) => {
    setUrlSearchParams({ page }, { append: true });
  };

  const downSm = useMediaQuery((theme: Theme) => {
    return theme.breakpoints.down("sm");
  });

  const page = urlSearchParams?.page || 1;

  if (!data?.itemArray) return null;

  return (
    <div
      data-testid="searchResult"
      className="w-full flex flex-col items-center gap-4"
    >
      {data.itemArray.length ? (
        <>
          <Container>
            {data.itemArray.map((lady, key) => {
              return (
                <LadyCardV3Basic
                  key={key}
                  ladyDto={lady}
                  toggleFavoriteLady={toggleLadyFavorite}
                />
              );
            })}
          </Container>
          <Pagination
            siblingCount={downSm ? 0 : 1}
            count={pageCount}
            page={page}
            setPage={mixPageToParams as Dispatch<SetStateAction<number>>}
            hideLastPagePaginationButton
          />
        </>
      ) : (
        <LadiesEmptyState />
      )}
    </div>
  );
};
